import { request } from "../@utils";
import { requestFile } from "../@utils";
const packageService = {
  createPackage: async (params) => {
    const res = await request.post("/package-unit/create",{ data: params });
    return res;
  },
  deletePackage: async (unitId) => {
    const res = await request.post(`/package-unit/delete/${unitId}`);
    return res;
  },
  disablePackage: async (unitId) => {
    const res = await request.get(`/package-unit/disable/${unitId}`);
    return res;
  },
  enablePackage: async (unitId) => {
    const res = await request.get(`/package-unit/enable/${unitId}`);
    return res;
  },
  getPackagePageList: async (params) => {
    const res = await request.post("/package-unit/page",{ data: params });
    return res;
  },
  updatePackage: async (params) => {
    const res = await request.post('/package-unit/update',{ data: params })
    return res;
  },
  exportPackage: async (params) => {
    const res = await requestFile.post('/package-unit/export',{ data: params, responseType: "blob"  })
    return res;
  }
};
export default packageService;